module.exports = __webpack_public_path__ + "static/media/document.80b60e9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/document.svg
// module id = 856
// module chunks = 0